import styled from "styled-components";

export const Container = styled.div`
    // .textCadastro{
    //     max-width: 1420px;
    //     width: 90%;
    //     margin: auto;
    // }
    // h3{
    //     text-align: center;
    //     font-size: 1.5em;
    //     font-weight: bold;
    //     text-transform: uppercase;
    //     color: #4e3628;
    // }
    // p{
    //     text-align: center;
    // }

    // .formArea{
    //     background-color: white;
    //     padding: 1.5rem;
    //     border-radius: 10px;
    //     max-width: 1420px;
    //     width: 90%;
    //     margin: 3rem auto 30px auto;
    // }
`;

